import type { ModalManager } from "@/modal-manager";
import type { CustomerInfoProviderInterface } from "@lib/CustomerInfoProvider/CustomerInfoProviderInterface";
import type GrowaveConfigurationEntity from "@lib/GrowaveConfigurationProvider/GrowaveConfigurationEntity";
import type { GrowaveConfigurationProviderInterface } from "@lib/GrowaveConfigurationProvider/GrowaveConfigurationProviderInterface";
import type { LocalizationInfoProviderInterface } from "@lib/LocalizationInfoProvider/LocalizationInfoProviderInterface";
import type { ProductIdManagerInterface } from "@lib/ProductIdManager/ProductIdManagerInterface";
import type { ProductVariantIdManagerInterface } from "@lib/ProductVariantIdManager/ProductVariantIdManagerInterface";
import type { ShopBrandInfoProviderInterface } from "@lib/ShopBrandInfoProvider/ShopBrandInfoProviderInterface";
import type { StorefrontApiAccessTokenProviderInterface } from "@lib/StorefrontApiAccessTokenProvider/StorefrontApiAccessTokenProviderInterface";
import type { SdkEventInterface } from "@modules/sdk/events/SdkEventInterface";
import type { InjectionToken } from "tsyringe";

import type GwStorefrontAppInfo from "@interfaces/GwStorefrontAppInfo";
import type { LoggerInterface } from "@interfaces/LoggerInterface";

export const localStorageToken = Symbol(
    "localStorageToken"
) as InjectionToken<Storage>;

export const globalLoggerToken = Symbol(
    "globalLoggerToken"
) as InjectionToken<LoggerInterface>;

export const gwStorefrontAppInfoToken = Symbol(
    "gwStorefrontAppInfoToken"
) as InjectionToken<GwStorefrontAppInfo>;

export const customerInfoProviderToken = Symbol(
    "customerInfoProviderToken"
) as InjectionToken<CustomerInfoProviderInterface>;

export const shopBrandInfoProviderToken = Symbol(
    "shopBrandInfoProviderToken"
) as InjectionToken<ShopBrandInfoProviderInterface>;

export const storefrontApiAccessTokenProviderToken = Symbol(
    "storefrontApiAccessTokenProviderToken"
) as InjectionToken<StorefrontApiAccessTokenProviderInterface>;

export const growaveConfigurationProviderToken = Symbol(
    "growaveConfigurationProviderToken"
) as InjectionToken<GrowaveConfigurationProviderInterface>;

export const growaveConfigurationToken = Symbol(
    "growaveConfigurationToken"
) as InjectionToken<GrowaveConfigurationEntity>;

export const modalManagerToken = Symbol(
    "modalManagerToken"
) as InjectionToken<ModalManager>;

export const localizationInfoProviderToken = Symbol(
    "localizationInfoProviderToken"
) as InjectionToken<LocalizationInfoProviderInterface>;

export const isEmbeddedModeToken = Symbol(
    "isEmbeddedModeToken"
) as InjectionToken<boolean>;

export const globalProductIdManagerToken = Symbol(
    "globalProductIdManagerToken"
) as InjectionToken<ProductIdManagerInterface>;

export const globalProductVariantsIdManagerToken = Symbol(
    "globalProductVariantsIdManagerToken"
) as InjectionToken<ProductVariantIdManagerInterface>;

export const dispatchSdkEventToken = Symbol(
    "dispatchSdkEventToken"
) as InjectionToken<(event: SdkEventInterface) => void>;
